export default [

     {
          path: '/vulnerability',
          name: 'Vulnerability',
          component: () => import("@/views/Page/Vulnerability/Vulnerability.vue"),
          meta: {
               title: 'Vulnerability',
          },
     }
];